// @flow
import React from 'react'
import I18n from 'i18n-react'
import mustache from 'mustache'

// types
import type { ColumnTypeDefaultProps } from './ColumnTypeDefault'
import { getValueForPath } from '../../FilterFunctions'

const getPriceIncludesDynamic = (data: Object, identifyObject?: Object) => {
  let priceIncludes = []
  if (data.priceIncludesDynamic && identifyObject) {
    let found = false
    data.priceIncludesDynamic.forEach((priceIncludeDynamic) => {
      if (priceIncludeDynamic.type.includes(identifyObject.type)) {
        found = true
        priceIncludes = [...priceIncludes, ...priceIncludeDynamic.values]
      }
    })
    if (!found && priceIncludes.length === 0 && data && data.priceIncludes) {
      priceIncludes = data.priceIncludes
    }
    return priceIncludes
  }
  return false
}

export const getPriceIncludes = (data: Object, identifyObject?: Object) => {
  let priceIncludes = getPriceIncludesDynamic(data, identifyObject)
  if (!priceIncludes && data && data.priceIncludes) {
    return data.priceIncludes
  }
  return priceIncludes || []
}

export type ColumnTypePriceIncludesProps = ColumnTypeDefaultProps & {
  blacklist: string[],
  hidePriceSummaryKeys?: Array<string>,
  removeDuplicatesFrom: Object,
  templateVariables: Object,
}

const ColumnTypePriceIncludes = (props: ColumnTypePriceIncludesProps) => {
  let priceIncludes = getPriceIncludes(props.data, props.identifyObject)
  if (props.removeDuplicatesFrom && typeof props.removeDuplicatesFrom === 'object') {
    const priceIncludesSecond = getPriceIncludes(props.removeDuplicatesFrom, props.identifyObject)
    priceIncludes = priceIncludes.filter((includes) => !priceIncludesSecond.includes(includes))
  }
  if (props.hidePriceSummaryKeys && Array.isArray(props.hidePriceSummaryKeys)) {
    // $FlowIssue
    priceIncludes = priceIncludes.filter((includes) => !props.hidePriceSummaryKeys.includes(includes))
  }
  priceIncludes = priceIncludes
    .map((includes) => {
      const text = getValueForPath(`priceIncludes.${includes}`, 0, I18n.texts || {})
      if (text && text.includes('{')) {
        return mustache.render(text, props.templateVariables)
      }
      return I18n.translate(`priceIncludes.${includes}`)
    })
    .filter((i) => !!i)
  return priceIncludes ? (
    <div className="list px-2">
      <ul className="list list-bullets child-mb-0 mb-0 mr-lg-2 px-2 px-lg-0">
        {priceIncludes.map((includes) => (
          <li key={includes}>
            <small>{includes}</small>
          </li>
        ))}
      </ul>
    </div>
  ) : null
}

export default ColumnTypePriceIncludes
